import {
  NBS_API_GET_SEARCH_CONTROLS_REQUEST,
  NBS_API_GET_SEARCH_CONTROLS_SUCCESS,
  NBS_API_GET_SEARCH_CONTROLS_FAILURE,
  SET_SEARCH_CONTROLS,
  UPDATE_SEARCH_CONTROLS,
  RESET_SEARCH_CONTROLS,
  TOGGLE_ADVANCED_SEARCH_CONTROLS
} from '../../constants/actions';

import nbsApi from '../../assets/helpers/nbsApi';
import strings from '../../assets/localization';

function nbsApiGetSearchControlsRequest () {
  return { type: NBS_API_GET_SEARCH_CONTROLS_REQUEST };
}
function nbsApiGetSearchControlsSuccess (response) {
  return {
    type: NBS_API_GET_SEARCH_CONTROLS_SUCCESS,
    response
  };
}
function nbsApiGetSearchControlsError (error) {
  return {
    type: NBS_API_GET_SEARCH_CONTROLS_FAILURE,
    error: error.cause || error
  };
}
export function nbsApiGetSearchControls (data) {
  const url = 'getProfileExtControls';
  if (!data.language) {
    data.language = strings.getLanguage();
  }
  return dispatch => {
    dispatch(nbsApiGetSearchControlsRequest());
    return nbsApi(url, data)
      .then(response => dispatch(nbsApiGetSearchControlsSuccess(response)))
      .catch(error => dispatch(nbsApiGetSearchControlsError(error)));
  };
}

export function setSearchControls (data) {
  return dispatch => dispatch({type: SET_SEARCH_CONTROLS, data});
}

export function updateSearchControls (data) {
  return dispatch => dispatch({type: UPDATE_SEARCH_CONTROLS, data});
}

export function resetSearchControls () {
  return dispatch => dispatch({type: RESET_SEARCH_CONTROLS});
}

export function toggleAdvancedSearchControls () {
  return dispatch => dispatch({type: TOGGLE_ADVANCED_SEARCH_CONTROLS});
}
